import Tibbit43Node from '@appblocks/codegeneration/Nodes/Tibbit43Node';
import { Setting, SettingType } from '@appblocks/codegeneration/types';

export default class Tibbit43_2Node extends Tibbit43Node {
    constructor() {
        super();
        this.name = 'Tibbit 43_2';
        this.id = 'node_tibbit_43_2';
        this.linkedFeature = 'tibbit_43_2';
        this.description = '4-Channel Streaming ADC ±100V';

        const settings: Setting[] = [
            {
                id: 'TIBBIT',
                name: 'Tibbit',
                settingType: SettingType.OPTION,
                required: true,
                refId: 'tibbit_43_2',
                default: '',
            },
        ];

        this.settings = this.settings.concat(settings);
    }
}
